import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';

@Component({
  selector: 'evland-loader',
  templateUrl: './loader.component.html',
  styleUrls: [ './loader.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgStyle,
  ],
})
export class LoaderComponent {
  size = input<number>(56);
  color = input<string>();

  iconStyle: Signal<{ [k: string]: number | string }>;
  strokeStyle: Signal<{ 'stroke-color': string }>;

  constructor() {
    this.iconStyle = computed(() => {
      const size = this.size();

      return {
        'width.px': size,
        'height.px': size,
      };
    });

    this.strokeStyle = computed(() => {
      const color = this.color();

      return {
        ...(color && { 'stroke-color': color }),
      };
    });
  }
}
